import * as Yup from 'yup';
import { Section } from '@models';

export function useValidationSchema() {
  return Yup.object<Section>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<Section>;
}
